import { GET_EMPLOYEE } from '@/api/master-data/employee/employee';

const state = {
    employees: [],
};

const mutations = {
    setEmployees: (state, payload) => {
        state.employees = payload;
    },
};

const actions = {
    getEmployees: async ({ commit }, params) => {
        try {
            const resp = await GET_EMPLOYEE(params);
            if (resp.data.httpCode === 200) {
                commit('setEmployees', resp.data.data); 
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp && resp.data && resp.data.httpCode === 404) {
                commit('setEmployees', []);
            }
            throw err;
        }
    },
};

const getters = {
    employees: (state) => state.employees,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
